import sample_1 from './ergocare.jpg';

export const ergocareImpressions = {
    sample_1,
};
